import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import type { MentionRenderers, MentionType } from "./mention-list";

/** Props Interface */
interface MentionItemProps extends NodeViewProps {
	mentionRenderers: MentionRenderers;
}

export function MentionItem(props: MentionItemProps) {
	/** Props */
	const type = props.node.attrs.type as MentionType;
	const label = props.node.attrs.label || "";

	/** Render */
	return (
		<NodeViewWrapper className="inline-flex w-fit">
			{props.mentionRenderers[type]
				? props.mentionRenderers[type](props.node.attrs.id, "inline")
				: label}
		</NodeViewWrapper>
	);
}
